export default __webpack_public_path__ + "static/media/circle_uncheck_yellow.d769076b.svg";